import api from '../../../services/api';

export const dashboardService = {
  getMonths: () => api.get('/transactions/months'),
  getDashboard: (params: { year?: number; month?: number; startDate?: string; endDate?: string; accountId?: string }) =>
    api.get('/transactions/dashboard', { params }),
  getAccounts: () => api.get('/accounts'),
  getGroups: () => api.get('/groups'),
  getClassifiers: () => api.get('/classifiers'),
  batchUpdate: (ids: string[], fields: Record<string, string | number | boolean | null>) =>
    api.patch('/transactions/batch', { ids, fields }),
  invertAmount: (ids: string[]) =>
    api.patch('/transactions/invert', { ids }),
  getDistinct: (field: string) => api.get(`/transactions/distinct/${field}`),
  createTransaction: (data: { description: string; amount: number; date: string; category?: string; groupId?: string; classifierId?: string; accountType?: string }) =>
    api.post('/transactions', data),
  deleteTransaction: (id: string) => api.delete(`/transactions/${id}`),
  createFromImage: (file: File) => {
    const form = new FormData();
    form.append('file', file);
    return api.post('/ai-transactions/from-image', form);
  },
  createFromAudio: (file: Blob, fileName: string) => {
    const form = new FormData();
    form.append('file', file, fileName);
    return api.post('/ai-transactions/from-audio', form);
  },
};
